var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyboxPig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 234,
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 228,
    height: 228,
    rx: 114,
    stroke: "#131313",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.123 89.375C60.123 89.375 53.623 92.625 53.623 100.75C53.623 107.032 58.7158 112.125 64.998 112.125H65.96",
    stroke: "#131313",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6096 80.6768C89.5321 80.183 89.4589 79.6892 89.4589 79.1738C89.4589 73.8235 93.8064 69.4695 99.1487 69.4695C103.395 69.4695 106.974 72.2363 108.279 76.0533C109.181 76.0059 110.077 75.939 110.992 75.939C112.342 75.939 113.675 76.008 114.999 76.1094C113.563 68.6522 107.006 63 99.1487 63C90.2427 63 82.999 70.2545 82.999 79.1738C82.999 80.8537 83.2574 82.4754 83.7333 84C85.5679 82.7579 87.5446 81.6602 89.6096 80.6768Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.123 115.375H169.124C166.229 105.771 159.176 97.4448 149.533 91.6175L149.546 91.6012L154.373 69.875C154.373 69.875 136.67 69.927 129.439 84.0515V84.0677C125.441 83.317 121.288 82.875 116.998 82.875C87.4291 82.875 63.3726 101.829 63.3726 125.125C63.3726 136.903 69.5346 147.56 79.4373 155.23L76.9998 161.782C74.8126 167.671 77.8123 174.219 83.6981 176.407C85.0046 176.891 86.3436 177.122 87.6598 177.122C92.2781 177.122 96.6201 174.288 98.3231 169.708L100.013 165.165C105.359 166.579 111.057 167.375 116.998 167.375C122.906 167.375 128.581 166.588 133.901 165.191L135.581 169.712C137.284 174.294 141.626 177.125 146.244 177.125C147.561 177.125 148.9 176.894 150.206 176.41C156.095 174.219 159.092 167.674 156.904 161.785L154.486 155.282C159.576 151.352 163.661 146.63 166.459 141.378H177.119C178.913 141.378 180.369 139.922 180.369 138.128V118.628C180.373 116.831 178.917 115.375 177.123 115.375Z",
    stroke: "#131313",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.747 127C150.508 127 152.747 124.761 152.747 122C152.747 119.239 150.508 117 147.747 117C144.986 117 142.747 119.239 142.747 122C142.747 124.761 144.986 127 147.747 127Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyboxPig);
export default __webpack_public_path__ + "static/media/moneybox-pig.ae3a6771eabb78d16c5c0ad9ba141889.svg";
export { ForwardRef as ReactComponent };